module.exports = "/lucky-balls/img/infobox/info_Box_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_013.png
// module id = 1078
// module chunks = 0